const PLACEHOLDER_URL_HOSTS = ["example.com", "example.net", "example.org"];

const INVALID_FORMAT_MESSAGE =
  "http:// または https:// で始まる正しい形式の URL を入力してください";

// 入稿画面で仮 URL（https://example.com/<番号>）の途中に記事 URL を貼り付けたまま保存される事故を防ぐ
// https://github.com/wantedly/visit/issues/16376
// サーバー側の Link#validate_admin_input_url と同じルールにする
export function validateLinkUrl(url: string): string | null {
  const value = url.trim();
  if (!value) {
    return "URL を入力してください";
  }

  let parsed: URL;
  try {
    parsed = new URL(value);
  } catch (e) {
    return INVALID_FORMAT_MESSAGE;
  }
  const host = parsed.hostname.toLowerCase();
  if (
    (parsed.protocol !== "http:" && parsed.protocol !== "https:") ||
    host.indexOf(".") === -1
  ) {
    return INVALID_FORMAT_MESSAGE;
  }

  if (PLACEHOLDER_URL_HOSTS.indexOf(host.replace(/^www\./, "")) !== -1) {
    return "仮の URL（example.com）のままです。記事の URL に置き換えてください";
  }

  const beforeQuery = value.split(/[?#]/)[0];
  const schemeCount = (beforeQuery.match(/https?:?\/\//gi) || []).length;
  if (/https?$/.test(host) || schemeCount > 1) {
    return "2 つの URL が連結されています。仮の URL の途中に貼り付けていないか確認してください";
  }

  return null;
}
